import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const reasons = [{
  title: 'Enfoque práctico',
  description: 'Menos teoría, más ejecución. Cada acción tiene un propósito claro.'
}, {
  title: 'Comunicación clara',
  description: 'Reportes directos, sin tecnicismos innecesarios. Siempre sabrás qué está pasando.'
}, {
  title: 'Mentalidad de resultados',
  description: 'El objetivo siempre es mejorar tus números, no solo gastar presupuesto.'
}, {
  title: 'Transparencia en métricas',
  description: 'Acceso completo a los datos. Sin cajas negras.'
}, {
  title: 'Eficiencia del presupuesto',
  description: 'Cada colón invertido se gestiona con responsabilidad y estrategia.'
}];
export function WhyWorkWithMe() {
  return <section id="por-que-nosotros" className="py-20 bg-white" data-id="element-167">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-169">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-170">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-8" data-id="element-171">
              Por qué trabajar con nosotros
            </h2>
            <div className="space-y-8" data-id="element-172">
              {reasons.map((reason, index) => <div key={index} className="flex items-start" data-id="element-173">
                  <div className="flex-shrink-0 mt-1" data-id="element-174">
                    <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-175">
                      <Check className="w-4 h-4 text-blue-600" data-id="element-176" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-177">
                    <h3 className="text-lg font-bold text-navy-900" data-id="element-178">
                      {reason.title}
                    </h3>
                    <p className="text-slate-600 mt-1" data-id="element-179">{reason.description}</p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative h-full min-h-[400px] bg-slate-100 rounded-2xl overflow-hidden" data-id="element-180">
            {/* Abstract representation of partnership/growth */}
            <div className="absolute inset-0 bg-gradient-to-br from-navy-900 to-slate-800 p-8 flex flex-col justify-between" data-id="element-181">
              <div className="w-16 h-16 bg-blue-600 rounded-lg opacity-20 mb-4" data-id="element-182"></div>
              <div className="space-y-4" data-id="element-183">
                <div className="h-2 bg-white/10 rounded w-3/4" data-id="element-184"></div>
                <div className="h-2 bg-white/10 rounded w-1/2" data-id="element-185"></div>
                <div className="h-2 bg-white/10 rounded w-5/6" data-id="element-186"></div>
              </div>
              <div className="mt-auto" data-id="element-187">
                <div className="text-white/90 text-2xl font-bold mb-2" data-id="element-188">
                  "Compromiso total con el crecimiento de tu negocio."
                </div>
                <div className="w-20 h-1 bg-blue-500 rounded-full mt-4" data-id="element-189"></div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}